module.exports = __webpack_public_path__ + "app/principal/modals/modal-platform-partner-history-12jgLmKs.html";